<kendo-dialog id="inactive-assess" title="Inactivate Related Service Line Items" class="custom-dialog" (close)="onCloseDialog()"
[width]="530" [maxHeight]="315">

    <div class="msg">Please set a new effective end date to inactivate {{relatedServiceSelection?.length}} line item(s). The selected line items will be set to inactive
        after the chosen date. </div>
    <div class="form-wrap" [formGroup]="form">
        <kendo-label text="Effective End Date" class="student-document__label"> </kendo-label>
        <kendo-datepicker calendarType="classic" formControlName="effectiveDate" rounded="large" 
             ></kendo-datepicker>
    </div>
    
    <kendo-dialog-actions>
            <button kendoButton  themeColor="error" (click)="inactive()" fillMode="solid">Inactivate</button>
    </kendo-dialog-actions>
</kendo-dialog>